import type { LoadTicket } from '@/lib/types'

export type FieldMap = { field: string; column: number }

export function parseCSVText(text: string, delimiter = ',', headerRow = true): string[][] {
  const lines = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n').filter(l => l.length > 0)
  const out: string[][] = []
  for (const line of lines) out.push(splitCSVLine(line, delimiter))
  return headerRow ? out.slice(1) : out
}

function splitCSVLine(line: string, delimiter: string): string[] {
  const res: string[] = []
  let cur = ''
  let inQuotes = false
  for (let i = 0; i < line.length; i++) {
    const ch = line[i]
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') { cur += '"'; i++ } else { inQuotes = !inQuotes }
    } else if (ch === delimiter && !inQuotes) {
      res.push(cur); cur = ''
    } else {
      cur += ch
    }
  }
  res.push(cur)
  return res
}

function parseDateWithFormat(raw: string, fmt?: string): string {
  const s = raw.trim()
  if (!s) return s
  // common formats
  if (!fmt || fmt === 'M/d/yy' || fmt === 'M/d/yyyy') {
    const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/)
    if (m) {
      let [ , mm, dd, yy ] = m
      if (yy.length === 2) yy = String(2000 + Number(yy))
      const iso = `${yy}-${mm.padStart(2,'0')}-${dd.padStart(2,'0')}`
      return iso
    }
  }
  if (fmt === 'yyyy-MM-dd' || /^\d{4}-\d{2}-\d{2}$/.test(s)) return s
  // fallback: return as-is
  return s
}

export function rowsToLoads(rows: string[][], mapping: FieldMap[], dateFormat?: string): LoadTicket[] {
  const numeric = new Set(['grossWeight','netTons','tareWeight'])
  const dateFields = new Set(['deliveredAt','loadedAt'])
  const loads: LoadTicket[] = rows.map((cols) => {
    const row: any = { id: `IMP-${crypto.randomUUID()}` }
    for (const m of mapping) {
      const raw = cols[m.column] ?? ''
      if (numeric.has(m.field)) row[m.field] = raw === '' ? undefined : Number(raw)
      else if (dateFields.has(m.field)) row[m.field] = parseDateWithFormat(raw, dateFormat)
      else row[m.field] = raw
    }
    if (!row.status) row.status = 'Delivered'
    if (!row.destination) row.destination = 'Holly Hill Export Yard'
    if (row.scaleNumber) row.id = `IMP-${row.scaleNumber}`
    else if (row.securityTag) row.id = `IMP-${row.securityTag}`
    return row as LoadTicket
  })
  return loads
}
